import { useEffect, useState } from 'react'

/**
 * Tracks a CSS media query from JS. Only for breakpoints that have to change
 * *behaviour* rather than styling — a view that disappears has to hand its
 * state back to another one, and CSS cannot reach React state. Prefer the
 * `mqFrom` helpers for anything that is purely visual.
 *
 * Guarded for environments without matchMedia (jsdom), where it reads false.
 */
const useMediaQuery = (query: string): boolean => {
  const supported = typeof window !== 'undefined' && !!window.matchMedia
  const [matches, setMatches] = useState(
    () => supported && window.matchMedia(query).matches
  )

  useEffect(() => {
    if (!supported) return
    const list = window.matchMedia(query)
    const onChange = (event: MediaQueryListEvent) => setMatches(event.matches)
    setMatches(list.matches)
    list.addEventListener('change', onChange)
    return () => list.removeEventListener('change', onChange)
  }, [query, supported])

  return matches
}

export default useMediaQuery
